/* global rp$, ga, tracking */
'use strict';
const get = require('lodash/get');
const clone = require('lodash/clone');
const Tracker = require('public/js/lib/tracker');
const debug = require('debug')('webstore:track');

const track = {
	debug: false,
	trackers: {},
	transaction: null
};

var _gaq = _gaq || [];

track.add_tracker = function(tracker_name, tracker_type, owner, is_ec) {
	if(tracker_name === false) {
		tracker_name = 'default';
	}
	this.trackers[tracker_name] = new Tracker(tracker_name, tracker_type, owner, is_ec);
	debug('add_tracker', tracker_name, tracker_type, owner, is_ec);
};

track.get_trackers = function(tracker_name) {
	var target_owner, target_trackers = [];
	tracker_name = (typeof tracker_name !== 'undefined') ? tracker_name : 'default';

	if (tracker_name === 'all') {
		rp$.each(this.trackers, function Tracker_Iterator(idx, tracker) {
			target_trackers.push(tracker);
		});
	} else if (tracker_name.match('owner:')) {
		target_owner = tracker_name.replace('owner:', '');
		rp$.each(this.trackers, function Tracker_Iterator(idx, tracker) {
			if (tracker.owner === target_owner) {
				target_trackers.push(tracker);
			}
		});
	} else if (tracker_name === 'ec') {
		rp$.each(this.trackers, function(idx, tracker) {
			if (tracker.is_ec) {
				target_trackers.push(tracker);
			}
		});
	} else {
		if (this.trackers.hasOwnProperty(tracker_name)) {
			target_trackers.push(this.trackers[tracker_name]);
		}
	}

	return target_trackers;
};

track.init = function () {
	// CUSTOMER ACCOUNTS
	for (let i = 0; i < tracking.google.analytics_ua_numbers.length; i++) {
		let uaNumber = tracking.google.analytics_ua_numbers[i];
		let accountId = 'cust_'+ i;
		ga('create', uaNumber, 'auto', {'name': accountId});
		ga(`${accountId}.set`, 'anonymizeIp', true);
		ga(accountId +'.require', 'displayfeatures'); // Display Features
		if (tracking.google.enhanced_ecommerce_enabled) {
			ga(accountId +'.require', 'ec'); // Enhanced Ecommerce
		}
		this.add_tracker(accountId, 'ua', 'customer', tracking.google.enhanced_ecommerce_enabled);
	}

	// RP ACCOUNTS
	if(tracking.google.rp_ua_numbers) {
		for (let i = 0; i < tracking.google.rp_ua_numbers.length; i++) {
			let rpAccount = tracking.google.rp_ua_numbers[i];
			// Always enable EC for rollup/virtual. Only enable for rpcust if rp_enhanced_ecommerce_enabled is true.
			const isEC = (tracking.google.rp_enhanced_ecommerce_enabled || (rpAccount.id === 'rollup') || (rpAccount.id === 'virtual'));

			// SET UP ACCOUNT
			ga('create', rpAccount.ua, 'auto', {'name': rpAccount.id});
			ga(rpAccount.id +'.require', 'displayfeatures');  // Display Features
			if (isEC) {
				ga(rpAccount.id +'.require', 'ec'); // Enhanced Ecommerce
			}
			ga(`${rpAccount.id}.set`, 'anonymizeIp', true);

			// DIMENSIONS
			ga(rpAccount.id +'.set', 'dimension1', tracking.dimensions.domain);
			ga(rpAccount.id +'.set', 'dimension2', tracking.dimensions.hash);
			ga(rpAccount.id +'.set', 'dimension3', tracking.dimensions.isLoggedIn);
			ga(rpAccount.id +'.set', 'dimension4', tracking.dimensions.carSelected);
			const storeType = (rp_app.env.is_webstore_plugin) ? 'Webstore_Plugin' : 'Webstore';
			ga(rpAccount.id +'.set', 'dimension5', storeType);

			this.add_tracker(rpAccount.id, 'ua', 'rp', isEC);
		}
	}

	// RP REPORTING
	this.add_tracker('rp-reporting', 'rp', 'rp');
};

track.track_event = function (event_args, options, name) {
	var trackers;
	var tracker;
	var i, j;

	trackers = this.get_trackers(name || 'owner:rp');
	for(i = 0, j = trackers.length; i < j; i++) {
		tracker = trackers[i];
		if (rp_app.env.google_analytics_enabled) {
			tracker.track_event(event_args, options);
		}
		debug('track_event', trackers[i], event_args, options);
	}
};

track.track_transaction = function (name) {
	var trackers, tracker, i, j;

	trackers = this.get_trackers(name);
	for(i = 0, j = trackers.length; i < j; i++) {
		tracker = trackers[i];
		if (rp_app.env.google_analytics_enabled) {
			tracker.track_transaction();
		}
		debug('track_transaction', trackers[i]);
	}
};

track.track_pageview = function (name, page) {
	var trackers;
	var tracker;
	var i, j;

	trackers = this.get_trackers(name);
	for(i = 0, j = trackers.length; i < j; i++) {
		tracker = trackers[i];
		if (rp_app.env.google_analytics_enabled) {
			tracker.track_pageview(page);
		}
		debug('track_pageview', trackers[i], page);
	}
};

track.track_pageview_all_trackers = function() {
	this.track_pageview('owner:customer');
	this.track_pageview('rollup');
	this.track_pageview('rpcust');
	this.track_pageview('virtual', tracking.page || 'other');
	this.track_pageview('rp-reporting', tracking.page || 'other');
};

track.track_ec_impressions = function() {
	const trackers = this.get_trackers('ec');
	rp$.each(trackers, function(idx, tracker) {
		if (rp_app.env.google_analytics_enabled) {
			tracker.track_ec_impressions();
		}
	});
};

track.track_ec_cart_event = function(eventName, product_details) {
	const trackers = this.get_trackers('ec');
	rp$.each(trackers, function(idx, tracker) {
		if (rp_app.env.google_analytics_enabled) {
			const productDetails = clone(product_details);
			const isProductPage = (tracking.google.page_type === 'product');
			if (isProductPage && (tracker.name === 'rollup' || tracker.name === 'virtual')) {
				// Add the inventory messaging key if it is set, otherwise use default value
				productDetails.dimension7 = get(tracking, 'dimensions.stockLevelMessaging', 'NoInventoryMessaging');
			}
			tracker.track_ec_cart_event(eventName, productDetails);
		}
	});
};

track.page_tracking = function (pageType) {
	if(pageType === 'checkout/completed' && tracking.transaction.track_transaction) {
		this.track_transaction('all');
	}
};

module.exports = track;
